module.exports = __webpack_public_path__ + "img/project-dummy.fe3b4dea.jpeg";